import React                             from 'react';
import { Container, Group, Stack, Text } from '@mantine/core';
import useIsMounted                      from '@hooks/use-is-mounted';
import {useBookingState} from "@core/providers/BookingStateProvider";


export const DxbPriceSummary: React.FC = () => {

    const isMounted = useIsMounted();

    const { dxbPricesCalculatedByRules } = useBookingState();

    return isMounted && (
        <Container m={0} p={0}>
            {
                dxbPricesCalculatedByRules?.map((priceItem, idx) => {
                    return (
                        <Stack key={idx}>
                            <Group mb={10} grow={true} spacing={0}>
                                <Text align="left">{priceItem.typeName}
                                    <Text align="left" size={10}>{priceItem.name}</Text>
                                </Text>
                                <Text align="right">AED {priceItem.amount}</Text>
                            </Group>

                        </Stack>
                    )
                })
            }
        </Container>
    )

}
